import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import type { PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormSelectBoardWithCreateNewOptionComponent, {
	NewBoardId,
} from 'webapp/components/form/select-board-with-create-new-option';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class BoardPopupChooseComponent extends PopupInnerModalComponent<PopupData.Board.Choose> {
	@tracked selectedBoardId = NewBoardId;

	// No existing dashboard has room for the blocks being added, so the list selects none.
	get isSelectDisabled() {
		return !this.selectedBoardId;
	}

	@action
	changeSelectedBoardId(boardId: string) {
		this.selectedBoardId = boardId;
	}

	@action
	selectBoard() {
		this.popupData.onBoardSelect(this.selectedBoardId);
		this.close();
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Databoards" @size="lg" />
			Select dashboard
		</div>
		<div class="content">

			<FormSelectBoardWithCreateNewOptionComponent
				@changeSelectedBoardId={{this.changeSelectedBoardId}}
				@requiredFreeSpaces={{this.popupData.requiredFreeSpaces}}
			/>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Cancel"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						@text="Select dashboard"
						@extraClass="save"
						@isDisabled={{this.isSelectDisabled}}
						@onTrigger={{this.selectBoard}}
					/>
				</div>
			</div>
		</div>
	</template>
}
